import {CONFIG} from '../config.js';
import { windowInfo } from './WindowInfo.js';
import './ResizeEnd.js';
import {pubsub} from './Pubsub.js'

/**
 * PCかSPかをブラウザの幅で判断する
 */
export class Pcsp {
	#mode;
	#oldMode;

	constructor(){

		this.#judge()
		$(window).on('resizeEnd', () => {
			this.#judge()
		});
	}

	#judge(){
		if (this.#mode) {
			this.#oldMode = this.#mode;
		}
		if (windowInfo.size.w > CONFIG.breakpoint) {
			this.#mode = 'pc'
		} else {
			this.#mode = 'sp'
		}

		if (this.#mode !== this.#oldMode) {
			$(window).trigger('pcsp:changed', this);
			pubsub.pub('pcsp:changed', this)
		}
	}

	/**
	 * PCかSPかの値
	 */
	get mode(){
		return this.#mode
	}

	/**
	 * ブレイクポイント
	 */
	get breakpoint () {
		return CONFIG.breakpoint;
	}
}



declare global {
	interface Window {
		pcsp: Pcsp
	}
}

/**
PCなのかSPなのかを（幅で）判断するやつ<br/>importするだけで使える
@fires pcsp:changed

@example JS
```js
import {pcsp} from '/assets/js/modules/Pcsp.js'
console.log(pcsp.mode)
console.log(pcsp.breakpoint)
$(window).on('pcsp:changed', (e, instance) => {
	console.log(instance.mode)
})
```
 */

export const pcsp = window.pcsp = new Pcsp();